function image_2x_modal() {
    const images = document.querySelectorAll('.image-2x .image-modal')

    images.forEach(image => {
        // Added check for initialization because of lazy loading articles
        // causing double click events.
        if (image.classList.contains('image-modal-init')) return

        image.classList.add('image-modal-init')

        image.addEventListener('click', function (event) {
            event.preventDefault()

            $(this).smodal({
                blockerClass: 'jquery-smodal image-modal',
                fadeDuration: 500,
            })
        })
    })
}

document.addEventListener('DOMContentLoaded', image_2x_modal)
